

// Services Img Imports
import Web from '../assets/images/Services/Web.png';
import Mobile from '../assets/images/Services/Mobile.png';
import UIUX from '../assets/images/Services/Design.png';

// Portfolio Img Imports
import Recruiting from '../assets/images/Portfolio/Recruiting.png';
import Stream from '../assets/images/Portfolio/Stream.png';
import Freelance from '../assets/images/Portfolio/Freelance.png';
import kubera from '../assets/images/Portfolio/Kubera.png';
import Lexonit from '../assets/images/Portfolio/Lexonit.png';
import Britbrain from '../assets/images/Portfolio/Britbrain.png';

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.png';
import Collaborative from '../assets/images/Advantages/Collaborative.png';
import Management from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

// Testimonials
import Sasha from '../assets/images/Testimonials/Sasha.jpg';
import Reiner from '../assets/images/Testimonials/Reiner.jpg';
import Kruger from '../assets/images/Testimonials/Kruger.jpg';

// TeamMembers
import CEO from '../assets/images/TeamMembers/CEO.jpg';
import HRD from '../assets/images/TeamMembers/HRD.jpg';
import Finance from '../assets/images/TeamMembers/Finance.jpg';
import ProjectManager from '../assets/images/TeamMembers/Project-manager.jpg';
import Frontend1 from '../assets/images/TeamMembers/Frontend1.jpg';
import Frontend2 from '../assets/images/TeamMembers/Frontend2.jpg';
import Backend1 from '../assets/images/TeamMembers/Backend1.jpg';
import Backend2 from '../assets/images/TeamMembers/Backend2.jpg';
import Mobile1 from '../assets/images/TeamMembers/Mobile1.jpg';
import Mobile2 from '../assets/images/TeamMembers/Mobile2.jpg';
import UIUX1 from '../assets/images/TeamMembers/UIUX1.jpg';
import UIUX2 from '../assets/images/TeamMembers/UIUX2.jpg';

export const Services = [
  {
    title: 'Web Development',
    imageUrl: Web,
    animation: 'left',
  },
  {
    title: 'Mobile Development',
    imageUrl: Mobile,
    animation: 'up',
  },
  {
    title: 'UI/UX Design',
    imageUrl: UIUX,
    animation: 'right',
  },
];

export const Portfolios = [
  {
    id: 'asd1293uasdads1',
    title: 'school-Application',
    imageUrl: Recruiting,
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    credit: ' ',
  },
  {
    id: 'asd1293uhjkhkjh2',
    title: 'Stream+',
    imageUrl: Stream,
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    credit: ' ',
  },
  {
    id: 'asd1293uvbvcbbd3',
    title: 'Freelance',
    imageUrl: Freelance,
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    credit: ' ',
  },
  {
    id: 'asd1293ufgdfgs4',
    title: 'Marketing-Website',
    imageUrl: kubera,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: ' ',
  },
  {
    id: 'asd1293ulskmnb5',
    title: 'Lexon-Website',
    imageUrl: Lexonit,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: ' https://www.lexonit.com/',
  },
  {
    id: 'asd1293ulkmnbj6',
    title: 'Britbrain-Website',
    imageUrl: Britbrain,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: 'https://britbrain.org/',
  },
];

export const Advantages = [
  [{
    title: 'Expert Team',
    description: 'Our experienced developers and designers specialize in creating seamless, user-friendly applications..',
    imageUrl: Communicative,
  },
  {
    title: ' Custom Solutions',
    description: 'We tailor every project to meet your unique business needs and industry standards. .',
    imageUrl: Management,
  }],
  [{
    title: 'Scalable & Secure​',
    description: 'Our applications are built for long-term growth, ensuring stability and security..',
    imageUrl: Collaborative,
  },
  {
    title: 'Latest Technologies',
    description: "We leverage modern frameworks like Next.js, React.js, React Native, and Node.js for efficient development..",
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  {
    id: 1,
    name: '---',
    company: 'Owner,',
    testimoni: 'Thanks for Racxstudio, you guys are the best! Keep up the great work!',
    // imageUrl: Sasha,
  },
  {
    id: 2,
    name: '---',
    company: 'Director, ',
    testimoni: 'I just wanted to let you know that it’s been great working with Racxstudio.',
    // imageUrl: Kruger,
  },
  {
    id: 3,
    name: '----',
    company: 'CEO, ',
    testimoni: 'Racxstudio is so great. Thank you so much for a job well done.',
    // imageUrl: Reiner,
  },
];

export const TeamMembers = [
  {
    name: '----',
    position: 'Mobile Developer',
    // imageUrl: Mobile2,
  },

  {
    name: '----',
    position: 'Back-End Developer',
    // imageUrl: Mobile2,
  },
  {
    name: '----',
    position: 'UI/UX Designer',
    // imageUrl: UIUX2,
  },
  {
    name: '----',
    position: 'Front-end Developer',
    // imageUrl: UIUX1,
  },
];
